<div class="betting-limit-change-notification" *ngIf="queuedBettingLimit">
	<span class="notification-icon ico-exclamation"></span>
	<label
		*ngIf="queuedBettingLimit.type === bettingLimitType.betCountLimit"
		[innerHTML]="'betting-limit.queued-limit.bets' | jurisdiction | translate: {
		   		amount: queuedBettingLimit.limitValue,
        		startDate: queuedBettingLimit.startDate | date: 'dd/MM/yyyy HH:mm'
			}"
		test-id="queued-limit"
	>
	</label>
	<label
		*ngIf="queuedBettingLimit.type === bettingLimitType.betSizeLimit"
		[innerHTML]="'betting-limit.queued-bet-size-limit' | jurisdiction | translate: {
			amount: queuedBettingLimit.limitValue,
			startDate: queuedBettingLimit.startDate | date: 'dd/MM/yyyy HH:mm'
		}"
		test-id="queued-limit"
	>
	</label>
	<label
		*ngIf="queuedBettingLimit.type === bettingLimitType.wageringLimit"
		[innerHTML]="'betting-limit.queued-limit.wagering' | jurisdiction | translate: {
		   		amount: queuedBettingLimit.limitValue | obgCurrency,
        		startDate: queuedBettingLimit.startDate | date: 'dd/MM/yyyy HH:mm'
			}"
		test-id="queued-limit"
	>
	</label>
	<label
		*ngIf="queuedBettingLimit.type === bettingLimitType.timedWageringLimit"
		[innerHTML]="'betting-limit.queued-limit.timed-wagering.' + (queuedBettingLimit.limitPeriod! | lowercase)
			| jurisdiction | translate: {
				amount: queuedBettingLimit.limitValue | obgCurrency,
				startDate: queuedBettingLimit.startDate | date: 'dd/MM/yyyy HH:mm'
			}"
		test-id="queued-limit"
	>
	</label>
</div>

<div class="betting-limit-change-notification" *ngIf="!queuedBettingLimit && activeBettingLimit?.endDate">
	<span class="notification-icon ico-exclamation"></span>
	<label
		[innerHtml]="'betting-limit.upcoming-deletion' | jurisdiction | translate: {
				endDate: activeBettingLimit?.endDate | date: 'short'}"
		test-id="deleted-limit"
	>
	</label>
</div>

<mat-card class="betting-limit-container">
	<h2>{{ 'betting-limit.title' | jurisdiction | translate }}</h2>
	<div>
		<span>{{ 'betting-limit.current-limit' | jurisdiction | translate }}</span>
		<div class="betting-limit-amount" *ngIf="activeBettingLimit; else noBettingLimit">
			<span
				*ngIf="activeBettingLimit.type === bettingLimitType.betCountLimit"
				[innerHtml]="'betting-limit.bets-per-day' | jurisdiction | translate: { amount: activeBettingLimit.limitValue }"
				test-id="current-limit"
				data-test-id="current-limit"
			>
			</span>
			<span
				*ngIf="activeBettingLimit.type === bettingLimitType.betSizeLimit"
				[innerHtml]="'betting-limit.cash-per-bet' | jurisdiction | translate: { amount: activeBettingLimit.limitValue | obgCurrency }"
				test-id="current-limit"
				data-test-id="current-limit"
			>
			</span>
			<span
				*ngIf="activeBettingLimit.type === bettingLimitType.wageringLimit"
				[innerHtml]="'betting-limit.cash-per-day' | jurisdiction | translate: { amount: activeBettingLimit.limitValue | obgCurrency }"
				test-id="current-limit"
				data-test-id="current-limit"
			>
			</span>
			<span
				*ngIf="activeBettingLimit.type === bettingLimitType.timedWageringLimit"
				[innerHtml]="'betting-limit.cash-per-period.' + (activeBettingLimit.limitPeriod! | lowercase)
				| jurisdiction | translate: {
					amount: activeBettingLimit.limitValue | obgCurrency
				}"
				test-id="current-limit"
				data-test-id="current-limit"
			>
			</span>
		</div>
		<ng-template #noBettingLimit>
			<div class="betting-limit-amount">
				<span
					[innerHtml]="'betting-limit.limit-none' | jurisdiction | translate"
					test-id="current-limit"
					data-test-id="current-limit"
				></span>
			</div>
		</ng-template>
	</div>

	<div class="btn-container" *ngIf="!isBettingLimitEdited">
		<button
			mat-flat-button
			color="primary"
			class="remove-limit"
			*ngIf="isDeleteLimitEnabled && (queuedBettingLimit || (activeBettingLimit && !activeBettingLimit.endDate))"
			(click)="submitRemoveBettingLimit()"
			[disabled]="isRemoveBettingLimitLoading"
			test-id="betting-limit-remove-btn"
		>
			<mat-spinner *ngIf="isRemoveBettingLimitLoading; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent
				>{{ 'betting-limit.delete-betting-limit' | jurisdiction | translate }}</ng-template
			>
		</button>

		<button
			mat-flat-button
			color="accent"
			(click)="toggleBettingLimitEdited()"
			[disabled]="isSetBettingLimitLoading"
			test-id="betting-limit-edit-btn"
			data-test-id="betting-limit-edit-btn"
		>
			<mat-spinner *ngIf="isSetBettingLimitLoading; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent>{{ 'betting-limit.edit-betting-limit' | jurisdiction | translate }}</ng-template>
		</button>
	</div>
</mat-card>

<mat-card class="betting-limit-edit" *ngIf="isBettingLimitEdited">
	<form [formGroup]="bettingLimitForm" #form="ngForm" test-id="betting-limit-form" data-test-id="betting-limit-form">
		<h2>{{ 'betting-limit.edit-your-limit' | jurisdiction | translate }}:</h2>

		<mat-radio-group
			formControlName="limitType"
			*ngIf="bettingLimitForm.value.limitType !== bettingLimitType.timedWageringLimit"
			class="betting-limit-radio-group"
		>
			<mat-radio-button
				test-id="betting-limit-wagering-limit"
				[value]="bettingLimitType.wageringLimit"
				[checked]="true"
				>{{ 'betting-limit.max-cash' | jurisdiction | translate }}</mat-radio-button
			>
			<mat-radio-button test-id="betting-limit-bet-size-limit" [value]="bettingLimitType.betSizeLimit"
				>{{ 'betting-limit.bet-size-limit' | jurisdiction | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<mat-form-field>
			<input
				matInput
				type="tel"
				[placeholder]="'betting-limit.limit-' + bettingLimitForm.value.limitType | jurisdiction | translate: {currency: currency?.code}"
				formControlName="limit"
				obgNumericNotZero
				test-id="betting-limit-input"
				data-test-id="betting-limit-input"
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			test-id="betting-limit-error-amount"
			[input]="bettingLimitForm.controls.limit"
			translationPrefix="betting-limit.amount"
		>
		</obg-common-validation-renderer>

		<mat-radio-group
			formControlName="limitPeriod"
			*ngIf="bettingLimitForm.value.limitType === bettingLimitType.timedWageringLimit"
		>
			<mat-radio-button test-id="betting-limit-daily" [value]="wageringLimitPeriod.daily" [checked]="true"
				>{{ 'betting-limit.daily' | jurisdiction | translate }}</mat-radio-button
			>
			<mat-radio-button test-id="betting-limit-weekly" [value]="wageringLimitPeriod.weekly"
				>{{ 'betting-limit.weekly' | jurisdiction | translate }}</mat-radio-button
			>
			<mat-radio-button test-id="betting-limit-monthly" [value]="wageringLimitPeriod.monthly"
				>{{ 'betting-limit.monthly' | jurisdiction | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<div class="btn-container">
			<button
				mat-flat-button
				(click)="toggleBettingLimitEdited()"
				test-id="betting-limit-edit-cancel"
				class="btn-container-cancel"
			>
				{{ 'general.cancel' | translate }}
			</button>
			<button
				mat-flat-button
				color="accent"
				[disabled]="!bettingLimitForm.valid"
				(click)="submitBettingLimit()"
				test-id="betting-limit-save-btn"
				data-test-id="betting-limit-save-btn"
			>
				{{ 'betting-limit.save-betting-limit' | jurisdiction | translate }}
			</button>
		</div>
	</form>
</mat-card>

<div class="caption" [innerHtml]="'betting-limit.caption' | jurisdiction | translate"></div>
